import { useState } from "react";

const PLACEHOLDER_ARTWORK = "https://collection.startlemusic.com/api/records/placeholder/artwork/embed";

export interface ArtworkProps {
  src?: string | null;
  alt?: string;
  className?: string;
}

export function Artwork({ src, alt = "", className }: ArtworkProps): React.JSX.Element {
  const source = src?.trim() || null;
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const imageSrc = source && source !== failedSrc ? source : PLACEHOLDER_ARTWORK;

  return (
    <img
      className={className}
      src={imageSrc}
      alt={alt}
      onError={() => {
        if (source) setFailedSrc(source);
      }}
    />
  );
}
